/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {ViewEncapsulation, isDevMode} from '@angular/core';

import {CompileIdentifierMetadata} from './compile_metadata';
import {Identifiers, createIdentifier} from './identifiers';
/**
 * @return {?}
 */
function unimplemented(): any {
  throw new Error('unimplemented');
}

export class CompilerConfig {
public renderTypes: RenderTypes;
public defaultEncapsulation: ViewEncapsulation;
private _genDebugInfo: boolean;
private _logBindingUpdate: boolean;
public useJit: boolean;
/**
 * @param {?=} __0
 */
constructor(
      {renderTypes = new DefaultRenderTypes(), defaultEncapsulation = ViewEncapsulation.Emulated,
       genDebugInfo, logBindingUpdate, useJit = true}: {
        renderTypes?: RenderTypes,
        defaultEncapsulation?: ViewEncapsulation,
        genDebugInfo?: boolean,
        logBindingUpdate?: boolean,
        useJit?: boolean
      } = {}) {
    this.renderTypes = renderTypes;
    this.defaultEncapsulation = defaultEncapsulation;
    this._genDebugInfo = genDebugInfo;
    this._logBindingUpdate = logBindingUpdate;
    this.useJit = useJit;
  }
/**
 * @return {?}
 */
get genDebugInfo(): boolean {
    return this._genDebugInfo === void 0 ? isDevMode() : this._genDebugInfo;
  }
/**
 * @return {?}
 */
get logBindingUpdate(): boolean {
    return this._logBindingUpdate === void 0 ? isDevMode() : this._logBindingUpdate;
  }
}

function CompilerConfig_tsickle_Closure_declarations() {
 /** @type {?} */
CompilerConfig.prototype.renderTypes;
 /** @type {?} */
CompilerConfig.prototype.defaultEncapsulation;
 /** @type {?} */
CompilerConfig.prototype._genDebugInfo;
 /** @type {?} */
CompilerConfig.prototype._logBindingUpdate;
 /** @type {?} */
CompilerConfig.prototype.useJit;
}

/**
 *  Types used for the renderer.
  * Can be replaced to specialize the generated output to a specific renderer
  * to help tree shaking.
 * @abstract
 */
export abstract class RenderTypes {
/**
 * @return {?}
 */
get renderer(): CompileIdentifierMetadata { return unimplemented(); }
/**
 * @return {?}
 */
get renderText(): CompileIdentifierMetadata { return unimplemented(); }
/**
 * @return {?}
 */
get renderElement(): CompileIdentifierMetadata { return unimplemented(); }
/**
 * @return {?}
 */
get renderComment(): CompileIdentifierMetadata { return unimplemented(); }
/**
 * @return {?}
 */
get renderNode(): CompileIdentifierMetadata { return unimplemented(); }
/**
 * @return {?}
 */
get renderEvent(): CompileIdentifierMetadata { return unimplemented(); }
}

export class DefaultRenderTypes implements RenderTypes {
/**
 * @return {?}
 */
get renderer() { return createIdentifier(Identifiers.Renderer); };
  renderText: any = null;
  renderElement: any = null;
  renderComment: any = null;
  renderNode: any = null;
  renderEvent: any = null;
}

function DefaultRenderTypes_tsickle_Closure_declarations() {
 /** @type {?} */
DefaultRenderTypes.prototype.renderText;
 /** @type {?} */
DefaultRenderTypes.prototype.renderElement;
 /** @type {?} */
DefaultRenderTypes.prototype.renderComment;
 /** @type {?} */
DefaultRenderTypes.prototype.renderNode;
 /** @type {?} */
DefaultRenderTypes.prototype.renderEvent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
